import { render, staticRenderFns } from "./BoardAdd.vue?vue&type=template&id=b1e67b62&"
import script from "./BoardAdd.vue?vue&type=script&lang=js&"
export * from "./BoardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports